import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterBooleanSearchValueObject} from './FilterBooleanSearchValueObject.js'

export class FilterHasOnlineFinancingSearchValueObject extends ValueObject {
  #hasOnlineFinancing

  constructor({hasOnlineFinancing}) {
    super()
    this.#hasOnlineFinancing = hasOnlineFinancing
  }

  static create({hasOnlineFinancing}) {
    return new FilterHasOnlineFinancingSearchValueObject({
      hasOnlineFinancing: FilterBooleanSearchValueObject.create(hasOnlineFinancing)
    })
  }

  static createWithDefaultValue({config, hasOnlineFinancing}) {
    const {DEFAULT_HAS_ONLINE_FINANCING_SEARCH} = config.get('searchFilters')

    return new FilterHasOnlineFinancingSearchValueObject({
      hasOnlineFinancing: FilterBooleanSearchValueObject.create({
        boolean: hasOnlineFinancing ?? DEFAULT_HAS_ONLINE_FINANCING_SEARCH
      })
    })
  }

  static createQueryParams({config, hasOnlineFinancing}) {
    const {DEFAULT_HAS_ONLINE_FINANCING_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterHasOnlineFinancingSearchValueObject({
      hasOnlineFinancing: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.HAS_ONLINE_FINANCING],
        value: hasOnlineFinancing === DEFAULT_HAS_ONLINE_FINANCING_SEARCH ? null : hasOnlineFinancing
      })
    })
  }

  get isEmpty() {
    return this.#hasOnlineFinancing.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#hasOnlineFinancing.queryParam})
    }
  }

  get value() {
    return this.#hasOnlineFinancing.value
  }

  toJSON() {
    return {
      hasOnlineFinancing: this.#hasOnlineFinancing.toJSON()
    }
  }
}
